<template>
  <div class="ggu-offer twentytwo">
    <div class="nav">
      <router-link to="/offer" tag="span" class="active"
        >offer龙虎榜</router-link
      >
      <router-link to="/" tag="span">学员申请总结</router-link>
    </div>
    <!--offer获得-->
    <div class="harvest">
      <div class="title-bar">
        <div class="left">
          <i class="iconfont icon-biaoqian"></i>世毕盟学员2022 Fall部分录取
        </div>
      </div>
      <div class="tips">以下录取案例，均实名制备案，接受学员和家长的监督!</div>

      <div class="list">
        <ul class="clear">
          <li
            v-for="(item, index) in twentytwoOfferCountList"
            :key="index"
            @click="showthisOffer(item.title)"
          >
            <div class="logo">
              <img :src="GetSrc(item.title)" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="count">{{ item.count }}</div>
          </li>
        </ul>
      </div>
    </div>

    <!--banner-->
    <!-- <div class="banner">
      <img src="@/assets/img/banner_2021.jpg" />
    </div> -->
    <!--<div class="other" @click="goOfferOther">
      2021 Fall offer龙虎榜 
      <span class="iconfont icon--_gengduo"></span>
    </div>-->

    <!--八大神校-->
    <div class="six-offer">
      <div class="title-bar">
        <img src="@/assets/img/six-offer-icon.png" />
        <span>八大神校</span>
        <img src="@/assets/img/six-offer-icon2.png" />
      </div>
      <ul class="list-data" id="list-data">
        <li
          class="ttuu"
          v-for="(item, index) in twentytwoOfferList"
          :key="index"
          :id="item.cate + '1'"
          :class="{ active: projectIndex == index }"
          @click="sixOfferClick(index, item)"
        >
          <div class="list">
            <div class="title">
              <span class="name">
                <i :class="{ active: projectIndex == index }"></i>
                {{ item.cate }}
              </span>
              <span class="count">{{ item.count }}</span>
            </div>
          </div>
          <div
            class="tips"
            v-for="(items, index) in item.list"
            :key="'i' + index"
            @click.stop="goVx(items.link)"
          >
            <div class="left">{{ items.serial_number }}<span>枚</span></div>
            <div class="center">{{ items.title }}</div>
            <div class="right">
              <img :src="imgUrl + items.image" />
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!--五大牛校-->
    <div class="six-offer z-six-offer">
      <div class="title-bar">
        <img src="@/assets/img/six-offer-icon.png" />
        <span>五大牛校</span>
        <img src="@/assets/img/six-offer-icon2.png" />
      </div>
      <ul class="list-data">
        <li
          v-for="(item, index) in zTwentytwoOfferList"
          :key="index"
          :id="item.cate + '2'"
          :class="projectIndex1 == index ? 'active' : ''"
          @click="zSixOfferClick(index, item)"
        >
          <div class="list">
            <div class="title">
              <span class="name">
                <i :class="{ active: projectIndex1 == index }"></i>
                {{ item.cate }}
              </span>
              <span class="count">{{ item.count }}</span>
            </div>
          </div>
          <div
            class="tips"
            v-for="(items, index) in item.list"
            :key="'i' + index"
            @click.stop="goVx(items.link)"
          >
            <div class="left">{{ items.serial_number }}<span>枚</span></div>
            <div class="center">{{ items.title }}</div>
            <div class="right">
              <img :src="imgUrl + items.image" />
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="pastLogo">
      <img src="@/assets/img/offer_2021.png" @click="goOfferOther('2021')" />
      <img src="@/assets/img/offer_2023.png" @click="goOfferOther('2023')" />
      <img src="@/assets/img/offer_2024.png" @click="goOfferOther('2024')" />
      <img src="@/assets/img/offer_2025.png" @click="goOfferOther('2025')" />
      <img src="@/assets/img/offer_2026.png" @click="goOfferOther('')" />
    </div>
  </div>
</template>

<script>
const imgUrl = "http://www.gguconsulting.com/Public/img/";
import api from "@/api/offer";
export default {
  data() {
    return {
      imgUrl,
      wxImg:
        "http://www.gguconsulting.com/try/sbm/Public/img/offer_share_2022.jpg",
      twentytwoOfferCountList: {}, //2021 offer获得
      twentytwoOfferList: {}, //2021 八大offer榜
      zTwentytwoOfferList: {}, //2021 准八大offer榜

      projectIndex: 0, //2021
      projectIndex1: 0,
    };
  },
  methods: {
    goOfferOther(year) {
      this.$router.push({
        path: "/offer" + year,
      });
    },
    //offer获得学习logo
    GetSrc(type) {
      switch (type) {
        case "Harvard":
          return require("../../assets/img/logo1.png");
        case "MIT":
          return require("../../assets/img/logo2.png");
        case "Princeton":
          return require("../../assets/img/logo3.png");
        case "Stanford":
          return require("../../assets/img/logo4.png");
        case "Berkeley":
          return require("../../assets/img/logo5.png");
        case "Caltech":
          return require("../../assets/img/logo6.png");
        case "Oxford":
          return require("../../assets/img/logo7.png");
        case "Cambridge":
          return require("../../assets/img/logo8.png");
      }
    },
    //去微信公众号
    goVx(link) {
      window.open(link, "_blank");
    },
    //八大神校榜折叠功能
    sixOfferClick(index) {
      if (this.projectIndex == index) {
        this.projectIndex = 1000;
      } else {
        this.projectIndex = index;
      }
    },
    //点击八大神校显示对于的详情
    showthisOffer(type) {
      this.projectIndex = type;
      let that = this;
      setTimeout(function () {
        window.scrollTo({
          top: document.querySelector("#" + type + "1").offsetTop,
          behavior: "smooth",
        });
      }, 301);
    },
    //五大牛校折叠功能
    zSixOfferClick(index) {
      if (this.projectIndex1 == index) {
        this.projectIndex1 = 1000;
      } else {
        this.projectIndex1 = index;
      }
    },
    //获取2022 offer数据
    async getTwentytwoOfferCountList() {
      try {
        let re = await api.twentytwo_offer_count_list();
        // this.twentytwoOfferCountList = re.data.data.list.sort((a, b) => a.id - b.id);
        this.twentytwoOfferCountList = re.data.data.list;
      } catch (error) {
        console.error(error);
      }
    },
    //获取2022 八大神校
    async GetTwentytwoOfferList() {
      try {
        let re = await api.twentytwo_offer_list();
        this.twentytwoOfferList = re.data.data.list;
        this.projectIndex = Object.keys(re.data.data.list)[0];
      } catch (error) {
        console.error(error);
      }
    },
    //获取2022 五大牛校
    async GetTwentytwoOfferQuasisixmajor() {
      try {
        let re = await api.twentytwo_fiveschool_list();
        this.zTwentytwoOfferList = re.data.data.list;
        this.projectIndex1 = Object.keys(re.data.data.list)[0];
      } catch (error) {
        console.error(error);
      }
    },
  },
  created() {
    this.getTwentytwoOfferCountList();
    this.GetTwentytwoOfferList();
    this.GetTwentytwoOfferQuasisixmajor();
    this.WXConfig.wxShowMenu(
      "2022世毕盟offer龙虎榜",
      "更好录取 有目共睹",
      "http://www.gguconsulting.com/try/sbm/index.php/#/offer",
      this.wxImg
    );
  },
};
</script>

<style lang="less" scoped>
//banner
.banner {
  width: calc(~"100% - 60px");
  margin-left: 30px;
  img {
    width: 100%;
    height: auto;
  }
}
//nav
.nav {
  height: 90px;
  border-bottom: 1px solid #e6e6e6;

  span {
    font-size: 32px;
    color: #192533;
    width: 50%;
    text-align: center;
    line-height: 90px;
    display: inline-block;
    font-weight: 600;
  }
  .active {
    color: #2a62d1;
    position: relative;
  }
  .active:before {
    border-bottom: 5px solid #2a62d1;
    bottom: 0;
    content: "";
    display: inline-block;
    left: calc(50% - 25px);
    position: absolute;
    width: 50px;
  }
}
//offer获得
.harvest {
  width: 100%;
  background: #fff;
  border-radius: 20px 20px 0px 0px;
  .title-bar {
    height: 80px;
    border-bottom: 1px solid #f7f7f7;
    line-height: 80px;
    .left {
      float: left;
      i {
        width: 16px;
        height: 21px;
        font-size: 28px;
        margin: 0 15px 0 30px;
        color: #000;
        display: inline-block;
      }
      font-size: 30px;
      color: #000;
      font-weight: 600;
    }
    .right {
      float: right;
      font-size: 22px;
      color: #999;
      margin-right: 25px;
    }
  }
  .tips {
    font-size: 26px;
    color: #b13143;
    margin: 21px 28px 26px;
  }
  .list {
    margin: 0 26px;
    padding-bottom: 17px;
    border-bottom: 1px solid #f7f7f7;
    li {
      width: calc(~"(100% - 54px) / 4");
      height: 174px;
      float: left;
      background: rgba(198, 50, 50, 0.1);
      margin: 0 18px 16px 0;
      border-radius: 10px;
      text-align: center;
      // font-family:"PingFang SC";
      .logo {
        width: 67px;
        height: 66px;
        border-radius: 50%;
        margin: 18px auto 5px auto;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .name {
        font-size: 24px;
        color: #333;
      }
      .count {
        font-size: 32px;
        font-weight: 600;
        color: #b82624;
      }
      &:nth-child(4n) {
        margin-right: 0px;
      }
      &:last-child {
        background: rgba(213, 89, 104, 0.1);
        .count {
          color: rgba(213, 89, 104, 1);
        }
      }
      &:nth-child(2) {
        background: rgba(198, 50, 50, 0.1);
        .count {
          color: rgba(198, 50, 50, 1);
        }
        img {
          background: url("../../assets/img/logo2.png");
        }
      }
      &:nth-child(3) {
        background: rgba(221, 131, 34, 0.1);
        .count {
          color: rgba(221, 131, 34, 1);
        }
      }
      &:nth-child(4) {
        background: rgba(156, 50, 50, 0.1);
        .count {
          color: rgba(156, 50, 50, 1);
        }
      }
      &:nth-child(5) {
        background: rgba(25, 63, 137, 0.1);
        .count {
          color: rgba(25, 63, 137, 1);
        }
      }
      &:nth-child(6) {
        background: rgba(243, 149, 48, 0.1);
        .count {
          color: rgba(243, 149, 48, 1);
        }
      }
      &:nth-child(7) {
        background: rgba(38, 58, 96, 0.1);
        .count {
          color: rgba(38, 58, 96, 1);
        }
      }
    }
  }
  .six-major {
    padding: 25px 26px;
    overflow: hidden;
    .left {
      width: 160px;
      height: 114px;
      border-radius: 10px;
      float: left;
      color: #fff;
      background: url("../../assets/img/z-six.png");
      background-size: 100% 100%;
      .name {
        font-size: 24px;
        margin: 29px 0 0 18px;
      }
      .count {
        font-size: 28px;
        font-weight: 600;
        margin-left: 18px;
      }
    }
    .right {
      float: right;
      width: calc(~"100% - 182px");
      margin-left: 21px;
      ul {
        overflow: hidden;
        background: rgba(42, 98, 209, 0.1);
        height: 114px;
        border-radius: 10px;
        margin-bottom: 19px;
        li {
          float: left;
          width: calc(~"(100%- 45px) / 4");
          margin-right: 15px;
          font-size: 24px;
          color: #333;
          text-align: center;
          span {
            display: block;
          }
          .name {
            margin: 20px 0 0 0;
          }
          .count {
            font-size: 32px;
            color: #2a62d1;
            font-weight: 600;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .ul-bottom {
        margin-bottom: 0;
      }
    }
  }
}
.other {
  border-top: 20px solid #f7f7f7;
  text-align: right;
  line-height: 80px;
  font-size: 28px;
  padding: 0 24px;
  span {
    font-size: 24px;
  }
}
//八大offer榜
.six-offer {
  border-top: 20px solid #f7f7f7;
  padding-bottom: 16px;
  .title-bar {
    text-align: center;
    font-weight: 600;
    font-size: 30px;
    color: #000;
    margin: 41px auto 33px;
    span {
      margin: 0 24px;
    }
    img {
      width: auto;
      height: 15px;
      position: relative;
      top: -2px;
    }
  }
  .list-data {
    li {
      margin-bottom: 10px;
      .list {
        font-size: 28px;
        color: #fff;
        padding: 0 25px;
        .title {
          height: 63px;
          line-height: 53px;
          overflow: hidden;
          .name {
            width: 237px;
            height: 53px;
            background: #162940;
            border-radius: 10px 0px 0px 10px;
            float: left;
            i {
              width: 0;
              height: 0;
              border-top: 7px solid #fff;
              border-bottom: 7px solid transparent;
              border-left: 7px solid transparent;
              border-right: 7px solid transparent;
              margin: 0 21px 0 25px;
              position: relative;
              top: 18px;
            }
            .active {
              border-top: 7px solid transparent;
              border-bottom: 7px solid #fff;
              border-left: 7px solid transparent;
              border-right: 7px solid transparent;
              margin: 0 21px 0 25px;
              position: relative;
              top: -18px;
            }
          }
          .count {
            float: left;
            width: calc(~"100% - 247px");
            height: 53px;
            margin-left: 10px;
            background: rgba(245, 246, 246, 1);
            border-radius: 0px 10px 10px 0px;
            text-align: center;
            color: #b13143;
          }
        }
      }
      .not-count {
        .title {
          i {
            opacity: 0;
          }
          .count {
            font-size: 26px;
            color: #a2a0a0;
          }
        }
      }
      .tips {
        margin: 0 30px;
        border-bottom: none;
        height: 0;
        overflow: hidden;
        transition: all 0.3s;
        &:last-child {
          border-bottom: none;
        }
        .left {
          float: left;
          width: 60px;
          margin: 25px 0 0;
          color: #b13143;
          font-size: 30px;
          span {
            font-size: 18px;
            transform: scale(0.7);
            margin-left: 2px;
          }
        }
        .center {
          width: 490px;
          float: left;
          margin: 20px 37px 15px 20px;
          color: #333;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .right {
          width: 73px;
          height: 73px;
          float: right;
          margin: 25px 0 0;
          img {
            width: 100%;
          }
        }
      }
    }
    .active {
      .tips {
        height: 125px;
        border-bottom: 1px solid #f7f7f7;
        &:last-child {
          margin-bottom: 10px;
        }
      }
    }
  }
}
//准八大offer榜
.z-six-offer {
  border-top: 1px solid #f7f7f7;
}
.pastLogo {
  position: fixed;
  bottom: 100px;
  right: 30px;
  width: 120px;
  height: auto;
  img {
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
  }
}
.twentytwo {
  .six-offer .list-data li .list .title .name {
    background: #ea2d29;
  }
}
</style>